import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/services/other/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
})
export class SpinnerComponent implements OnInit {
  isVisible: boolean = false;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit() {
    this.spinnerService.isVisible$.subscribe((isVisible) => {
      this.isVisible = isVisible;
    });
  }
}
